exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._3QNtEXBrC5CoJLhJruwt-0{padding:1.42857rem}@media only screen and (min-width:640px){._3QNtEXBrC5CoJLhJruwt-0{padding:2.14286rem}}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"WritingAssignment_container": "_3QNtEXBrC5CoJLhJruwt-0"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"root":".","modules":true,"import":false,"importLoaders":1}!../node_modules/postcss-loader/lib?{"config":{"path":"/var/lib/jenkins/workspace/build-omni-operation-ui_develop/node_modules/omni-common-ui/postcss.config.js"}}!./containers/Group/WritingAssignment/style.postcss
// module id = 1847
// module chunks = 0